/**
 * Kiểu giao diện. Hai bộ, chủ quán tự chọn ở Cài đặt:
 *
 *   Modern  — bảng điều khiển rộng, có thanh trên, dải điều hướng bên trái thu gọn,
 *             thẻ màu và biểu đồ nhỏ. Hợp máy quầy và máy tính bảng nằm ngang.
 *   Classic — bộ gốc: một cột, nút to, không trang trí. Hợp điện thoại cầm một tay.
 *
 * Đọc bằng localStorage chứ không phải kho dữ liệu chính, và cố ý như vậy: đây là sở
 * thích của <b>cái máy này</b>, không phải dữ liệu của quán. Quan trọng hơn, localStorage
 * đọc được ngay lập tức, nên khung giao diện vẽ đúng ngay từ khung hình đầu tiên. Đọc từ
 * IndexedDB thì phải chờ, và người dùng sẽ thấy giao diện nhảy một cái khi app khởi động.
 */

export type Skin = 'modern' | 'classic'

const KEY = 'sigopos:skin'

export const SKINS: { id: Skin; label: string; hint: string }[] = [
  { id: 'modern', label: 'Modern', hint: 'Bảng điều khiển rộng, thẻ màu. Hợp máy quầy, máy bảng.' },
  { id: 'classic', label: 'Classic', hint: 'Một cột, nút to, gọn gàng. Hợp điện thoại cầm một tay.' },
]

/**
 * Bộ mặc định.
 *
 * Modern là bộ chính. Classic giữ lại nguyên vẹn cho ai đã quen tay — đổi giao diện của
 * một cái máy tính tiền đang chạy là bắt người bán học lại chỗ bấm giữa lúc đông khách,
 * nên phải luôn có đường quay về.
 */
const FALLBACK: Skin = 'modern'

export function readSkin(): Skin {
  try {
    const saved = localStorage.getItem(KEY)
    if (saved === 'modern' || saved === 'classic') return saved
  } catch {
    // Cửa sổ ẩn danh hoặc máy chặn quyền lưu trữ. Không phải lỗi — dùng bộ mặc định.
  }
  return FALLBACK
}

/** Gắn lên thẻ gốc để CSS bắt được, và ghi nhớ cho lần mở app sau. */
export function applySkin(skin: Skin): void {
  document.documentElement.dataset.skin = skin
  try {
    localStorage.setItem(KEY, skin)
  } catch {
    // Không ghi nhớ được thì thôi, giao diện vẫn đổi cho phiên này.
  }
}
